import { render, staticRenderFns } from "./node.vue?vue&type=template&id=bd3da7a8&scoped=true"
import script from "./node.vue?vue&type=script&lang=js"
export * from "./node.vue?vue&type=script&lang=js"
import style0 from "./node.vue?vue&type=style&index=0&id=bd3da7a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3da7a8",
  null
  
)

export default component.exports